import { useDispatch, useSelector } from 'react-redux';
import {
    selectHasIsolatedRoutes,
    selectShouldFitPlanMapToBounds,
    selectIsMultipleCardSelectEnabled,
    selectViewCardDetails,
    setHasIsolatedRoutes as updateHasIsolatedRoutes,
    setIsMultipleCardSelectEnabled as updateIsMultipleCardSelectEnabled,
    setShouldFitPlanMapToBounds as updateShouldFitPlanMapToBounds,
    setViewCardDetails as updateViewCardDetails
} from '~/reducers/mapSettingsSlice';

export const useIsolatedRoutes = () => {
    const dispatch = useDispatch();

    const hasIsolatedRoutes = useSelector(selectHasIsolatedRoutes);

    const shouldFitPlanMapToBounds = useSelector(
        selectShouldFitPlanMapToBounds
    );

    const isMultipleCardSelectEnabled = useSelector(
        selectIsMultipleCardSelectEnabled
    );

    const viewCardDetails = useSelector(selectViewCardDetails);

    const setHasIsolatedRoutes = (value) => {
        return dispatch(updateHasIsolatedRoutes(value));
    };

    const setIsMultipleCardSelectEnabled = (value) => {
        return dispatch(updateIsMultipleCardSelectEnabled(value));
    };

    const setShouldFitPlanMapToBounds = (value) => {
        return dispatch(updateShouldFitPlanMapToBounds(value));
    };

    const setViewCardDetails = (value) => {
        return dispatch(updateViewCardDetails(value));
    };

    const isolateSingleRoute = (isolate = true) => {
        setHasIsolatedRoutes(isolate);
        setIsMultipleCardSelectEnabled(false);
        setViewCardDetails(false);
    };

    const isolateMultipleRoutes = (isolate = true) => {
        setHasIsolatedRoutes(isolate);
        setIsMultipleCardSelectEnabled(isolate);
        setViewCardDetails(isolate);
    };

    return {
        hasIsolatedRoutes,
        shouldFitPlanMapToBounds,
        isMultipleCardSelectEnabled,
        viewCardDetails,
        setHasIsolatedRoutes,
        setIsMultipleCardSelectEnabled,
        setShouldFitPlanMapToBounds,
        setViewCardDetails,
        isolateSingleRoute,
        isolateMultipleRoutes
    };
};
